export default {
    action: {
        addNew: 'Add New',
        addToQuote: 'Add to Quote',
        ahsUpload: 'AHS Upload',
        ahsTempDownload: 'AHS Template',
        booking: 'Booking',
        cancel: 'Cancel',
        clpInfoTempDL: 'Container Info Template Download',
        confirm: 'Confirm',
        createQuote: 'Create Quote',
        deleteConfirm: 'Unable to be recovered if deleted, please confirm',
        delete: 'Delete',
        edit: 'Edit',
        expUPSUpload: 'UPS Base Upload',
        expUSPSUpload: 'USPS Base Upload',
        expFDXUpload: 'FDX Base Upload',
        fbaComparison: 'FBA Comparison',
        fbaCalculator: 'FBA Calculator',
        fdxBaseTempDownload: 'FDX BaseRates Template',
        fileSelect: 'Select File',
        getQuote: 'Get Quote',
        getPDF: 'PDF',
        instruction: 'Instruction',
        imex: 'Im/Export',
        next: 'Next',
        oceanFreightTempDownload:'OceanFreight Template Download',
        oceanFreightRatesUpload:'OceanFreight Rates Upload',
        operation: 'Operation',
        refresh: 'Refresh',
        review: 'Review',
        resultDownload: 'Result Download',
        previous: 'Previous',
        showDetails: 'Show Details',
        submitUpload: 'Submit Upload',
        templateDownload: 'Exp Bill Template Download',
        uomSys: 'UOM System',
        uspsPeakFeeUpload: 'USPS PeakFee Upload',
        uspsPeakFeeDownload: 'USPS PeakFee Template',
        uspsBaseTempDownload: 'USPS BaseRates Template',
        upsBaseTempDownload: 'UPS BaseRates Template',
        vue2: 'OF Upload Vue2',
        vue3: 'Ocean Freight',
        warehouseRatesUpload:'Warehouse Rates Upload',
        warehouseTempDownload: 'WareHouse Template Download'
    },
    agentFee: {
        title: 'Agent Fee',
        id: 'Id',
        vendor: 'Vendor',
        srvPort: 'Service Port',
        ctnrType: 'ContainerType',
        currency: 'Currency',
        rates: 'Rates',
        legcode: 'Leg Code',
        chargeType: 'Charge Type',
        chargeDescription: 'Charge Description',
        uom: 'UOM',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
        rctag: 'RC Tag',
    },
    allCHB: {
        title: 'CHB',
        id: 'Id',
        vendor: 'Vendor',
        srvPort: 'Service Port',
        legcode: 'Leg Code',
        chargeType: 'Charge Type',
        chargeDescription: 'Charge Description',
        rates: 'Rates',
        uom: 'UOM',
        currency: 'Currency',
        adjust: 'Adjust',
        notes: 'Notes',
        rctag: 'RC Tag',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    basicInfo: {
       ctnrCounts:'Container Counts'
    },
    chargecode: {
        title: 'Charge Code',
        chainLocation: 'Chain Location',
        leg: 'Leg',
        chargeType: 'Charge Type',
        uom: 'UOM',
        chargeDescription: 'Charge Description',
        legcode: 'Leg Code',
        legseq: 'Leg Seq',
        apcode: 'AP Code',
        notes: 'Notes'
    },
    chart:{
        unit:'$',
        rates: 'rates',
        ofRatesTitle:'Ningbo-Los Angeles 40HQ Ocean Freight Rates From Carriers',
        fbaCostTitle: 'FBA Cost Pie of Packing Size: 30x20x10(inch), 10(lb), 15days Storage',
        expCostTitle: 'Express Cost Comparison of Packing Size: 30x20x10(inch), 10(lb), Zone 4',
        bestRates: 'Best Rates',
        secondBest: 'Second Best',
        thirdBest: 'Third Best',
        fourthBest:'Fourth Best'
    },
    chassis:{
        title: 'Chassis',
        id: 'ID',
        chassisId: 'Chassis ID',
        status: 'Status',
        type: 'Chassis Type',
        dailyCost: 'Daily Cost USD',
        expDate: 'Expiration Date',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
        inclExcl: 'Incl or Excl (1/0)',
    },
    client: {
        title: 'Client',
        id: 'Id',
        shortName: 'Short Name',
        legalName: 'Legal Name',
        type: 'Type',
        status: 'Status',
        einortaxid: 'Ein/Tax Id',
        w9link: 'W9 Link',
        dunScore: 'Dun Score',
        creditLimit: 'Credit Limit',
        contractStatus: 'Contract Status',
        contactName: 'Contact Name',
        contactTitle: 'Contact Title',
        email: 'Email',
        phone: 'Phone',
        country: 'Country',
        region: 'Region',
        address: 'Address',
        otruckpterm: 'OTruckPTerm',
        ochbpterm: 'OCHBPTerm',
        owhspterm: 'OWHSPTerm',
        odraypterm: 'ODrayPTerm',
        agentpterm: 'AgentPTerm',
        nvopterm: 'NVOPTerm',
        p2ppterm: 'P2PPTerm',
        dchbpterm: 'DCHBPTerm',
        ddraypterm: 'DDrayPTerm',
        dwhspterm: 'DWHSPTerm',
        dtruckpterm: 'DTruckPTerm',
        expresspterm: 'ExpressPTerm',
        otherspterm: 'OthersPTerm',
        sales: 'Sales',
        csr: 'Customer Service',
        oop: 'Origin OP',
        dop: 'Destination OP',
        csopemail: 'CSOP Email',
        linkedEntities: 'Linked Entities',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    bookContract: {
        title: 'BookContract',
        id: 'Id',
        trackNumber: 'TrackingNumber',
        l3Owner: 'L3Owner',
        clientName: 'ClientName',
        broker: 'Broker',
        payTerm: 'PaymentTerm',
        quoteTotal: 'Quote Total',
        targetMargin: 'Target Margin',
        marginpct: 'Margin Percent',
        pdf: 'Contract In PDF',
        oceanFreight: 'Ocean Freight',
        origAgent: 'oAgent',
        origChb: 'oCHB',
        origDray: 'oDray',
        origWarehouse: 'oWarehouse',
        origTruck: 'oTruck',
        origExpress: 'oExpress',
        destAgent: 'dAgent',
        destChb: 'dCHB',
        destDray: 'dDray',
        destWarehouse: 'dWarehouse',
        destTruck: 'dTruck',
        destExpress: 'dExpress',
        origAir: 'oAir',
        destAir: 'dAir',
        origRail: 'oRail',
        destRail: 'dRail',
        status: 'Status',
        basicinfo: 'BasicInfo',
        documents: 'Documents',
        shipinfo: 'ShipInfo',
        paymentinfo: 'PaymentInfo',
        notes: 'Notes',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    packingSummary: {
        sku: 'SKU',
        cartons: 'Cartons',
        pallets: 'Pallets'
    },
    drayage: {
        title: 'Dray Service',
        id: 'Id',
        vendor: 'Vendor',
        validStart: 'Valid Start',
        validEnd: 'Valid End',
        fromArea: 'From Area',
        toArea: 'To Area',
        desType: 'Dest Type',
        dropType: 'Drop Type',
        drayage: 'Dray Service',
        bobtail: 'Bobtail',
        total: 'Total',
        remark: 'Remark',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    draySrvFee: {
        title: 'Dray Service Fee',
        id: 'Id',
        legcode: 'Leg Code',
        chargeType: 'Charge Type',
        chargeDescription: 'Charge Description',
        uom: 'UOM',
        rates: 'Rates',
        adjust: 'Adjust',
        rctag: 'RC Tag',
        notes: 'Notes',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    expAHS: {
        title: 'ExpAHS',
        id: 'Id',
        chargeDescription: 'Charge Description',
        zone2: 'Zone2',
        zone3: 'Zone3',
        zone4: 'Zone4',
        zone5: 'Zone5',
        zone6: 'Zone6',
        zone7: 'Zone7',
        zone8: 'Zone8',
        toAk: 'To AK',
        toHi: 'To HI',
        vendor: 'Vendor',
        courier: 'Courier',
        rctag: 'RC Tag',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    expListUSA:{
        title: 'ExpListUSA',
        id: 'Id',
        lspname: 'LSP Name',
        courier: 'Courier',
        product: 'Product',
        srvstate: 'Service State',
        rctag: 'RC Tag',
        validStart: 'Valid Start',
        validEnd: 'Valid End',
        notes: 'Notes',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time'
    },
    expressCost: {
        title: 'ExpressCost',
        id: 'Id',
        refid: 'Ref ID',
        vendor: 'Vendor',
        courier: 'Courier',
        fromZip: 'From Zip',
        toZip: 'To Zip',
        zone: 'Zone',
        resiAddr: 'Resi/Comm Addr',
        peak: 'Peak Time',
        pkgs: 'Packages',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        weight: 'Weight',
        girth: 'Girth',
        billWeight: 'Billed Weight',
        baseRate: 'Base Rate',
        ahsWeight: 'AHS Weight',
        ahsLength: 'AHS Length',
        ahsWidth: 'AHS Width',
        ahsGirth: 'AHS Girth',
        ahsPackage: 'AHS Package',
        lpsCom: 'LPS Com',
        lpsRes: 'LPS Res',
        uos: 'Over Max Limits',
        resSurcharge: 'Res Surcharge',
        fsc: 'Fuel Surcharge',
        peakTotalsc: 'Peak Surcharge Total',
        notes: 'Notes',
        vendorsrvfee: 'Vendor Service Fee',
        dasRes: 'DAS Res',
        dasCom: 'DAS Com',
        dasExtRes: 'DAS Ext Res',
        dasExtCom: 'DAS Ext Com',
        total: 'Total',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    expressFDX: {
        title: 'Fedex',
        id: 'Id',
        weight: 'Weight',
        zone2: 'Zone2',
        zone3: 'Zone3',
        zone4: 'Zone4',
        zone5: 'Zone5',
        zone6: 'Zone6',
        zone7: 'Zone7',
        zone8: 'Zone8',
        toAk: 'To AK',
        toHi: 'To HI',
        vendor: 'Vendor',
        rctag: 'RC Tag',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    expressUPS: {
        title: 'ExpressUPS',
        id: 'Id',
        weight: 'Weight',
        zone2: 'Zone2',
        zone3: 'Zone3',
        zone4: 'Zone4',
        zone5: 'Zone5',
        zone6: 'Zone6',
        zone7: 'Zone7',
        zone8: 'Zone8',
        zone44: 'Zone44',
        zone45: 'Zone45',
        zone46: 'Zone46',
        vendor: 'Vendor',
        rctag: 'RC Tag',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    expOtherFee: {
        title: 'ExpOtherFee',
        id: 'Id',
        pkfGround: 'PeakFeeGround',
        pkfAhs: 'PeakFeeAHS',
        pkfLps: 'PeakFeeLPS',
        pkfUos: 'PeakFeeUOS',
        pkfResideli: 'PeakResidentialDelivery',
        resideli: 'ResidentialDelivery',
        fsc: 'Fuel Surcharge',
        dimIndex: 'DimensionWeightIndex',
        lspHdlfee: 'LSPHandleFee',
        dasCom: 'DAS Commercial',
        dasRes: 'DAS Residential',
        dasexdcom: 'DAS EXD Commercial',
        dasexdres: 'DAS EXD Residential',
        dasAk: 'DAS AK',
        dasHi: 'DAS HI',
        uos: 'Ultra OverSize',
        vendor: 'Vendor',
        courier: 'Courier',
        rctag: 'RC Tag',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    expUSPS: {
        title: 'ExpUSPS',
        id: 'Id',
        weight: 'Weight',
        unit: 'Unit',
        zone1: 'Zone1',
        zone2: 'Zone2',
        zone3: 'Zone3',
        zone4: 'Zone4',
        zone5: 'Zone5',
        zone6: 'Zone6',
        zone7: 'Zone7',
        zone8: 'Zone8',
        zone9: 'Zone9',
        nc6: 'NC6',
        nc7: 'NC7',
        nc8: 'NC8',
        vendor: 'Vendor',
        rctag: 'RC Tag',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    eTower:{
        title: 'eTower',
        bookedServices:'Booked Services',
        createOrders: 'Create Orders',
        nativeName: 'Native Name',
        printLabel: 'Print Labels',
        quoteInquiry: 'Quote Inquire',
        serviceCode: 'Service Code',
        serviceName: 'Service Name',
        serviceProvider: 'Service Provider',
        serviceProviderCode: 'Service Provider Code',
        serviceDescription: 'Service Description',
        tracking:'Tracking',
    },
    fBACost: {
        title: 'FBACost',
        id: 'Id',
        refid: 'Ref ID',
        sku: 'SKU',
        lowprice: 'Low Priced',
        apparel: 'Apparel',
        peak: 'Peak Time',
        pkgs: 'Packages',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        weight: 'Weight',
        billWeight: 'Billed Weight',
        sizetier: 'Size Tier',
        baseRate: 'Base Rate',
        ibplacefee: 'Inbound Place Fee',
        stodays: 'Storage Days',
        stocost: 'Storage Cost',
        peakTotalsc: 'Peak Surcharge Total',
        otherfee: 'Other Fees',
        total: 'Total',
        notes: 'Notes',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    globalPort: {
        title: 'GlobalPort',
        id: 'Id',
        portCode: 'Port Code',
        city: 'City',
        state: 'State',
        country: 'Country',
        swRegion: 'Region',
        seaport: 'Sea Port',
        dryport: 'Dry Port',
        barge: 'Barge',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    instruction: {
       upsRateCardsUpload:'1.Fill all the blanks in the form such as vendor, product, valid start and end date etc-->'+
           '2.Click “UPS Base Rates Template” Download-->' +
           '3.Click “AHS Template” Download-->' +
           '4.Complete these 2 templates and upload both according to the instruction of upload buttons-->' +
           '5.Now the “Submit Upload” Button will be effective-->' +
           '6.Click “Submit Upload”-->' +
           '7.If upload successful, the web page will jump to Express Delivery Rate Cards List',
        fdxRateCardsUpload:'1.Fill all the blanks in the form such as vendor, product, valid start and end date etc-->'+
            '2.Click “FDX Base Rates Template” Download-->' +
            '3.Click “AHS Template” Download-->' +
            '4.Complete these 2 templates and upload both according to the instruction of upload buttons-->' +
            '5.Now the “Submit Upload” Button will be effective-->' +
            '6.Click “Submit Upload”-->' +
            '7.If upload successful, the web page will jump to Express Delivery Rate Cards List'
        ,
        uspsRateCardsUpload:'1.Fill all the blanks in the form such as vendor, product, valid start and end date etc-->'+
            '2.Click “USPS Base Rates Template” Download-->' +
            '3.Click “USPS PeakFee Template” Download-->' +
            '4.Complete these 2 templates and upload both according to the instruction of upload buttons-->' +
            '5.Now the “Submit Upload” Button will be effective-->' +
            '6.Click “Submit Upload”-->' +
            '7.If upload successful, the web page will jump to Express Delivery Rate Cards List'
        ,
    },
    issuedquotes: {
        title: 'Issued Quotes',
        id: 'Id',
        pdf: 'QuoteFileName',
        l3Owner: 'L3Owner',
        clientName: 'ClientName',
        payTerm: 'PaymentTerm',
        broker: 'Broker',
        validby: 'ValidBy',
        fak: 'FAK',
        hazdg: 'Hazard Goods',
        srvCategory: 'Service Category',
        usdExchrate: 'USD Exchange',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
        quoteTotal: 'Quote Total',
        targetMargin: 'Target Margin',
        marginpct: 'Margin Percent',
        oceanFreight: 'Ocean Freight',
        oAgent: 'Origin Agent',
        oChb: 'Origin CHB',
        oDray: 'Origin Dray',
        oWarehouse: 'Origin Warehouse',
        oTruck: 'Origin Truck',
        oExpress: 'Origin Express',
        dAgent: 'Dest Agent',
        dChb: 'Dest CHB',
        dDray: 'Dest Dray',
        dWarehouse: 'Dest Warehouse',
        dTruck: 'Dest Truck',
        dExpress: 'Dest Express',
        oAir: 'Origin Air',
        dAir: 'Dest Air',
        oRail: 'Origin Rail',
        dRail: 'Dest Rail',
        status: 'Status',
        notes: 'Notes',
    },
    legCode: {
        title: 'Leg Code',
        id: 'Id',
        legseq: 'Leg Sequence',
        legcode: 'Leg Code',
        chainLocation: 'ChainLocation',
        role: 'Role',
        legtype: 'Leg Type',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    login: {
        welcomeText: 'Comprehensive Rates Inquiry for Cargo, Freight Forward, Custom Clearance, Dray, Truck, Courier',
        homepage: 'HomePage',
        onlineERP: 'Online ERP',
        username: 'Username',
        password: 'Password',
        loginSys: 'Login',
        loginByUsername: 'Login ByU Username',
        logout: 'Log Out',
        changePSD: 'Change Password',
        sendCode: 'Send Code',
        qrcode: 'Login By QR Code'
    },
    navBar: {
        administrative: 'Administrative',
        adminPanel: 'Admin Panel',
        approval: 'Request for Approval',
        billcheck: 'Bill Check',
        createNewRateCard:'Create New Rate Card',
        comboQuotes: 'Combo Quotes',
        department: 'Department',
        dashboard: 'Dashboard',
        disciplinaryFines: 'Disciplinary Fines',
        e2e: 'E2E',
        employ: 'Employee',
        express: 'Express',
        expbillcheck:'ExpBillCheck',
        externalAPI: 'External API',
        issuedquotes: 'Issued Quotes',
        leaveRequest: 'Leave Request',
        lang: 'Globalization',
        master: 'Master',
        meetings: 'Meetings',
        meetingRoom: 'Meeting Room',
        multiSize:'Multi-Size',
        myTicket: 'My Ticket',
        navigate: 'Navigate',
        onlineMeetings: 'Online Meetings',
        offlineMeetings: 'Offline Meetings',
        oceanFreight: 'Ocean Freight',
        passenger: 'Passenger',
        quotes: 'Quotes',
        rates: 'Rates',
        ratecards: 'Rate Cards Management',
        ratebyuom:'Rate By UOM',
        ratesComparison: 'Rates Comparison Charts',
        reimburse: 'Reimburse',
        rcUpload: 'RateCard Upload',
        role: 'Role',
        seatStats: 'Seat Statistics',
        singleSize: 'Single-Size',
        ticketsAvailable: 'Tickets Available',
        test: 'Test',
        user: 'User',
        welcome: 'Welcome',
    },
    oceanFreight: {
        title: 'Ocean Freight',
        id: 'Id',
        vendor: 'Vendor',
        pol: 'POL',
        destination: 'Destination',
        validStart: 'Valid Start',
        validEnd: 'Valid End',
        carrier: 'Carrier',
        pod: 'POD',
        ipi: 'IPI',
        ctnrType: 'ContainerType',
        rates: 'Rates',
    },
    oTHC: {
        title: 'OTHC',
        id: 'Id',
        srvPort: 'Service Port',
        carrier: 'Carrier',
        ctnrType: 'Container Type',
        rates: 'Rates',
        currency: 'Currency',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    originSrvFee: {
        title: 'Origin Service',
        id: 'Id',
        vendor: 'Vendor',
        pol: 'POL',
        ctnrType: 'Container Type',
        currency: 'Currency',
        rates: 'Rates',
        legcode: 'Leg Code',
        chargeType: 'Charge Type',
        chargeDescription: 'Charge Description',
        uom: 'UOM',
        rctag: 'RC Tag',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    paymentFactor: {
        title: 'PaymentFactor',
        id: 'Id',
        clientTier: 'Client Tier',
        paymentTerm: 'Payment Term',
        lane: 'Lane',
        minMargin: 'MinMargin',
        markup: 'Markup',
        maxMargin: 'MaxMargin',
        roundFactor: 'RoundFactor',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    placeholder: {
        timeSelect: 'Please Select Time',
        dateSelect: 'Please Select Date'
    },
    passenger: {
        passenger: 'Passenger',
        passengerName: 'Name',
        passengerId: 'ID',
        passengerType: 'Type'
    },
    quotes: {
        title: 'Quotes',
        id: 'Id',
        vendor: 'Vendor',
        legcode: 'Leg Code',
        chargeType: 'Charge Type',
        chargeDescription: 'Charge Description',
        rateType: 'Rate Type',
        rateDetail: 'Rate Detail',
        uom: 'UOM',
        rates: 'Rates',
        rateL4: 'Rate L4',
        apUnits: 'AP Units',
        apValue: 'AP Value',
        arUnits: 'AR Units',
        arValue: 'AR Value',
        apInv: 'AP Invoice',
        arInv: 'AR Invoice',
        apDisp: 'AP Dispute',
        arDisp: 'AR Dispute',
        legseq: 'Leg sequence',
        currency: 'Currency',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    rateByUOM:{
        pol:'POL',
        peak:'Peak',
        resiAddr:'Residential Address',
        uomSystem:'UOM System',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        weight: 'Weight',
        packages: 'Packages',
        storageDays: 'Storage Days',
        oceanFreight: 'Ocean Freight',
        agent: 'Agent',
        chb: 'CHB',
        dray: 'Dray',
        warehouse: 'Warehouse',
        truck: 'Truck',
        express: 'Express',
        total: 'Total',
        perKg: 'Per Kg',
        perLb: 'Per Lb'
    },
    shipInfo: {
        title: 'ShipInfo',
        id: 'ID',
        trackNumber: 'Tracking Number',
        clientName: 'Client Name',
        mbl: 'MBL',
        ctnrId: 'Container ID',
        pol: 'POL',
        pod: 'POD',
        podRegion: 'POD Region',
        ctnrType: 'Container Type',
        ctnrKg: 'Container KG',
        goodsName: 'Goods Name',
        danger: 'Danger',
        shipStatus: 'Ship Status',
        destSite: 'Dest Site',
        destCode: 'Dest Code',
        destAddr: 'Dest Address',
        erAddr: 'EmptyReturn Address',
        carrier: 'SSL Carrier',
        firmsCode: 'Firms Code',
        ddray: 'Dest Dray Vendor',
        etd: 'ETD',
        atd: 'ATD',
        eta: 'ETA',
        ata: 'ATA',
        discharge: 'Discharge Date',
        lfd: 'Terminal LFD',
        fullGateout: 'Full Gate Out',
        dwhcrdd: 'Dest WH CRDD',
        dwhArrival: 'Dest WH Arrival',
        dwhEmptynotify: 'Dest WH Empty Notify',
        emptyReturnappt: 'EmptyReturn Appt',
        emptyReturn: 'EmptyReturn Date',
        termpickupapp: 'Terminal Pickup Appt',
        chassisId: 'Chassis ID',
        paydue: 'Payment Due',
        paystatus: 'Payment Status',
        desType: 'Dest Type',
        dropType: 'Drop Type',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    toast: {
        loginFailed: 'Not Signed In or Time Out!',
        deleteSuccess: 'Delete Successful!',
        loginSuccess: 'Login Successful!',
        saveSuccess: 'Save Successful!',
        sendCodeSuccess: 'Send Code Successful!',
        switchLangSuccess: 'Switch Language Successful!'
    },
    truckUSFTL: {
        title: 'Truck',
        id: 'Id',
        vendor: 'Vendor',
        desType: 'Dest Type',
        fromArea: 'From Area',
        legcode: 'Leg Code',
        total: 'Total',
        toArea: 'To Area',
        rates: 'Rates',
        city: 'City',
        notes: 'Notes',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    uSPSOtherFee:{
        title: 'USPSOtherFee',
        id: 'Id',
        overlength: 'Over Length Surcharge',
        oversize: 'Over Size Surcharge',
        overlengthlimit: 'Over Length Limit Surcharge',
        overvolume: 'Over Volume Surcharge',
        dimIndex: 'DimensionWeightIndex',
        lspHdlfee: 'LSPHandleFee',
        vendor: 'Vendor',
        rctag: 'RC Tag',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    uSPSPeakFee:{
        title: 'USPSPeakFee',
        id: 'Id',
        weight: 'Weight',
        unit: 'Unit',
        zone1: 'Zone1',
        zone2: 'Zone2',
        zone3: 'Zone3',
        zone4: 'Zone4',
        zone5: 'Zone5',
        zone6: 'Zone6',
        zone7: 'Zone7',
        zone8: 'Zone8',
        zone9: 'Zone9',
        nc6: 'NC6',
        nc7: 'NC7',
        nc8: 'NC8',
        vendor: 'Vendor',
        rctag: 'RC Tag',
        validStart: 'Valid Start',
        validEnd: 'Valid End',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    vendor: {
        title: 'Vendor',
        id: 'Id',
        shortName: 'ShortName',
        legalName: 'LegalName',
        type: 'Type',
        status: 'Status',
        einortaxid: 'Ein/TaxId',
        w9link: 'W9link',
        dunScore: 'DunScore',
        creditLimit: 'Credit Limit',
        contractStatus: 'Contract Status',
        contactName: 'Contact Name',
        contactTitle: 'Contact Title',
        email: 'Email',
        phone: 'Phone',
        country: 'Country',
        region: 'Region',
        address: 'Address',
        otruck: 'O Truck',
        ochb: 'O CHB',
        owhs: 'O WHS',
        odray: 'O Dray',
        agent: 'Agent',
        nvo: 'NVO',
        p2p: 'P2P',
        dchb: 'D CHB',
        ddray: 'D Dray',
        dwhs: 'D WHS',
        dtruck: 'DTruck',
        express: 'Express',
        others: 'Others',
        vm: 'VM',
        op: 'OP',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    vin:{
        title: 'Trailer Usage',
        id: 'ID',
        vinId: 'VIN ID',
        status: 'Status',
        driver: 'Driver',
        logDate: 'Log Date',
        startHour: 'Start Hour',
        endHour: 'End Hour',
        odoStart: 'Odometer Start ',
        odoEnd: 'Odometer End',
        createBy: 'Created By',
        createTime: 'Created At',
        updateBy: 'Updated By',
        updateTime: 'Updated At',
        inclExcl: 'Incl/Excl',
    },
    wareHouse: {
        title: 'WareHouse',
        id: 'Id',
        vendor: 'Vendor',
        srvPort: 'Service Port',
        chargeType: 'Charge Type',
        chargeDescription: 'ChargeDescription',
        rateType: 'Rate Type',
        ctnrType: 'Container Type',
        uom: 'UOM',
        rates: 'Rates',
        tieredJson: 'TieredJson',
        currency: 'Currency',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
    },
    wHS:{
        title: 'WHS',
        id: 'ID',
        whsId: 'Whs ID',
        whsName: 'Whs Name',
        clientId: 'Client ID',
        status: 'Status',
        pic: 'Person In Charge',
        phone: 'PIC Phone',
        email: 'PIC Email',
        address1: 'Address Line 1',
        address2: 'Address Line 2',
        city: 'City',
        state: 'State',
        zip: 'Zipcode',
        country: 'Country',
        workday: 'Work Days',
        startTime: 'Start Time',
        closeTime: 'Close Time',
        gated: 'Gated',
        dlAppt: 'Delivery Appt',
        drop: 'Accept Drop',
        live: 'Accept Live',
        comment: 'Comment',
        createBy: 'Created By',
        createTime: 'Created At',
        updateBy: 'Updated By',
        updateTime: 'Updated At',
        inclExcl: 'Incl/Excl',
    },
}
